import { useMemo } from 'react';

const STACKED_WIDTH_BASE = 90;
const STACKED_WIDTH_REDUCTION_PER_INDEX = 4;

interface UseToastStackProps {
  readonly index: number;
  readonly totalToasts: number;
  readonly expanded: boolean;
}

export const useToastStack = ({ index, totalToasts, expanded }: UseToastStackProps) => {
  return useMemo(() => {
    const isFront = index === 0;
    const shouldCollapse = !expanded && totalToasts > 1;
    const shouldStack = shouldCollapse && !isFront;
    const toastWidth = shouldStack ? `${STACKED_WIDTH_BASE - index * STACKED_WIDTH_REDUCTION_PER_INDEX}%` : '100%';
    const shouldShowContent = expanded || isFront;

    return {
      isFront,
      shouldCollapse,
      shouldStack,
      toastWidth,
      shouldShowContent,
    };
  }, [index, totalToasts, expanded]);
};
